export const SET_MEMBER_ID = 'SET_MEMBER_ID'
export const SET_MEMBER_ROLE = 'SET_MEMBER_ROLE'



// WEBPACK FOOTER //
// ./src/store/modules/admin/hangfire/types.js